import { React, useState,useEffect } from "react";
import styled from "styled-components"
import Button from '@mui/material/Button';
import { apiMain } from "../../App";
import { GetDataPromise, PostDataPromise } from "../Functions/SendingData";
// import { DictioneryPanel } from '../../../Data/DictioneryPanel';
import BoxDesign from '../reports/BoxDesign';
import Paper from '@mui/material/Paper';
import img from '../images/Room1.png';
import log from '../images/LuxinHotel.png';
//import log1 from '../images/imgtest.png'
import hmap from '../images/hotelmap.png';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Loading } from "../Loading";


const PrintStyle = styled.div`-direction-print-right: 0;
  --direction-print-left: 1;
  --ad-prime-1: var(--n-grey-1);
  --main-color: var(--n-grey-2);
  font-family: var(--font-en) !important;
  * {
    font-family: var(--font-en) !important;
  }
  /* direction: rtl; */
  &.agency {
    --main-color: #6C648B;
    --ad-prime-1: #6C648B20;
  }
  &.broker {
    --main-color: #FEA202;
    --ad-prime-1: #FEA20220;
  }
  &.rtl {
    direction: ltr;
    font-family: var(--font-fa) !important;
    * {
      font-family: var(--font-fa) !important;
    }
    --direction-print-right: 0;
    --direction-print-left: 1;
  }
  @page {
  size: portrait;
}
.print-footer {
  position: fixed;
  bottom: 0;
}
  .print-header {
    margin: 0 0 2rem;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.7rem;
    align-items: center;
    font-size: 1.2rem;
    .header-row {
    width: calc(100% - 2rem);
      padding: 1rem;
      font-weight: 700;
    }
    .expand {
      flex-grow: 1;
    }
    .image {
      width: 80px;
      height: 80px;
      border-radius: 200px;
      border: 1px solid var(--n-grey-2);
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }
    }
    .dates {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      .date {
        display: flex;
        justify-content: space-between;
        gap: 0.5rem;
      }
    }
  }
`

export default function HotelVoucher_Pdf(props) {
   const [Reserv_Checkindate, setReserv_Checkindate] = useState("");
   const [Reserv_Checkoutdate, setReserv_Checkoutdate] = useState("");
  const [Pass_Id, setPass_Id] = useState(0);
  const [Night_No,setNight_No]=useState(0);
  const[Reserv_Base_Price,setReserv_Base_Price]=useState(0);
  const[Reserv_Rate,setReserv_Rate]=useState(0);
  const[Reserv_Price,setReserv_Price]=useState(0);
  const[Reserv_BreakfastAmount,setReserv_BreakfastAmount]=useState(0);
  const[Reserv_ExtraAmount,setReserv_ExtraAmount ]=useState(0);
  const[Reserv_Other,setReserv_Other]=useState(0);
  const[Reserv_Discount,setReserv_Discount]=useState(0);
  const[Reserv_prepayment,setReserv_prepayment]=useState(0);
  const[Reserv_Total,setReserv_Total]=useState(0);
  const[Reserv_Gel,setReserv_Gel]=useState(0);
  const [Prese_Name, setPrese_Name] = useState('');
  const [prese_UrlFile, setprese_UrlFile] = useState('');
  const [DataView, setDataView] = useState([]);
  const log2 = 'https://lhapi.luxintrip.com/images/image3.jpg';
 const {mytoday ,setMyToday}=useState("");

 const [Mydate , setMydate] =useState("");
  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);

  useEffect(() => {
    getmytoday();
      getData();
   getShowData();
  }, [])
 

  const getmytoday =()=>
  {
    let date1  =new Date();
       let mon = 0;
       mon = date1.getMonth()+1;
    setMydate(date1.getFullYear() + '-' + mon+ '-' + date1.getDate());
  //  setMydate('2025-1-3');
  
  }
  const getShowData = async () => {
    setLoading1(true);
    { <Loading small={true} /> }
    let uparams = new URLSearchParams();
    uparams.append("Pass_Id", props.pass_id);
    console.log("Pass_Id", props.pass_id);
    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectpersons?${uparams}`, true);

    // let res = await GetDataPromise(`${apiMain}/api/v1/reservation`, force);
    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      console.log(newData)
      setDataView(newData)
      
    }
    setLoading1(false);

 //   setLoading(false)

  }
  const copyImgToClipboard = async (animal)=> {
  const URL ='https://lhapi.luxintrip.com/api/v1/presents/selectpresentId?Prese_Id=3' //animal
 // const URL =`https://www.js-craft.io/_public-files/img-cat.png`
    

    // console.log(URL)
    try {
        const copiedImage = await fetch(URL)
  // console.log(copiedImage) 
        const blobData = await copiedImage.blob()
            
        const clipboardItemInput = new ClipboardItem({'image/png' : blobData})
         //    console.log(clipboardItemInput)
        navigator.clipboard.write([clipboardItemInput])
        const clipboardItems = await navigator.clipboard.read()
   
        const blobOutput = await clipboardItems[0].getType('image/png')
        const data = global.URL.createObjectURL(blobOutput)
  
        setprese_UrlFile(data)
    } catch(e) {
        console.log(e)
    }
}
  const getData = async () => {
    setLoading1(true);
  
    { <Loading small={true} /> }
    let uparams = new URLSearchParams();
    uparams.append("Reserv_Id", localStorage.getItem('Reserv_Id'));
    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/selectreservid?${uparams}`, true);

    let parsed = JSON.parse(res);
// console.log(localStorage.getItem('Reserv_Id'))
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      localStorage.setItem('Pass_Id',newData[0].Pass_Id)
      setPass_Id(newData[0].Pass_Id)
      setPrese_Name(newData[0].Prese_Name);
          setReserv_Checkindate(newData[0].Reserv_Checkindate.slice(0,10))
    setReserv_Checkoutdate(newData[0].Reserv_Checkoutdate.slice(0,10))
    setNight_No(newData[0].Night_No)
    setReserv_Base_Price(newData[0].Reserv_Base_Price)
    setReserv_Rate(newData[0].Reserv_Rate)
    setReserv_Total(newData[0].Reserv_Total)
    setReserv_Gel(newData[0].Reserv_Gel)

    setReserv_BreakfastAmount(newData[0].Reserv_BreakfastAmount)
    setReserv_ExtraAmount(newData[0].Reserv_ExtraAmount)
    setReserv_Other(newData[0].Reserv_Other)
    setReserv_prepayment(newData[0].Reserv_prepayment)
    // setReserv_prepayment(newData[0].Reserv_Pay)
    setReserv_Price(newData[0].Reserv_Price)


    console.log(newData[0])
    let  uparams1 = new URLSearchParams();
      uparams1.append("Prese_Id", 3);
      
    copyImgToClipboard(`${apiMain}/api/v1/presents/selectpresentId?${uparams1}`);

    //  setprese_UrlFile(newData)
// console.log(newData[0].prese_UrlFile)
//       const img = await fetch(newData[0].prese_UrlFile, { mode: 'no-cors', referrerPolicy: "no-referrer"});
//        console.log(img)
//       const imgBlob = await img.blob();
   
//       try {
//          navigator.clipboard.write([
//            new ClipboardItem({
//                'image/png': imgBlob, // change image type accordingly
//            })
//          ]);
//        } catch (error) {
//            console.error(error);
//        }
//     const URL ='https://lhapi.luxintrip.com/images/image3.png' //animal
// //const URL =`https://www.js-craft.io/_public-files/img-cat.png`
//       let blob1 = await fetch(URL, { mode: 'no-cors', referrerPolicy: "no-referrer"});

//             console.log(blob1)
//     //  blob = blob.getReader({mode: "byob"});

//   const blobData = await blob1.blob()
//    //   blob = new Blob(blob);
    
//       let dataUrl = await new Promise(resolve => {
//         let reader = new FileReader();
//         reader.onload = () => resolve(reader.result);
//         reader.readAsDataURL(blobData);
//       });
//       console.log(dataUrl)
//      setprese_UrlFile(dataUrl);
      

    // setprese_UrlFile(newData[0].prese_UrlFile)
 //    setprese_UrlFile(`https://lhapi.luxintrip.com/images/image3.png`)


//log2=newData[0].prese_UrlFile
    }
    setLoading1(false);
  }
  const solveOnlineImg = () => (
    <div>
    <img src={prese_UrlFile}/>

    </div>
    )
  const generateInvoice = () => {
    // Validate the input fields

    let doc = new jsPDF("p", "pt");

    // Add invoice header
    doc.setFontSize(24);
    doc.text("Invoice", 40, 60);
    doc.setFontSize(10);
    doc.text("Invoice Number: 123456", 40, 90);
    doc.text("Date: " + new Date().toDateString(), 40, 110);
    doc.text(`Hotel Name: Luxin Hotel`, 40, 130);
    doc.text(` Address: 12-4 konstantin Eristavi Dead end, Tbilisi`, 40, 150);

    // Add items section
    doc.setFontSize(14);
    doc.text("Items:", 40, 200);
    doc.line(40, 210, 550, 210);

    // Add item details
    doc.setFontSize(12);
    let yOffset = 240;
    let total = 0;
    // Add total
    doc.line(40, yOffset, 550, yOffset);
    doc.setFontSize(14);
    doc.text(`Total: $${total}`, 400, yOffset + 30);

    // Save the generated PDF as "invoice.pdf"
    doc.save("invoice.pdf");

    // Reset error state
    // setError(false);
  };
  const printDocument = async () => {
    const input = document.getElementById("divToPrint");
  
    const canvas = await html2canvas(input, {
      imageTimeout: 9000,
      removeContainer: true,
      scale: 2, // کیفیت بهتر
    });
  
    const imgData = canvas.toDataURL("image/png");
  
    // ایجاد PDF با سایز A4
    const pdf = new jsPDF("p", "mm", "a4");
  
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
  
    // تبدیل اندازه‌ی تصویر به میلی‌متر
    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width; // تناسب تصویر
  
    // اگر ارتفاع تصویر بیشتر از A4 بود → صفحات اضافه
    if (imgHeight <= pdfHeight) {
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    } else {
      let position = 0;
      let heightLeft = imgHeight;
  
      while (heightLeft > 0) {
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
        position -= pdfHeight;
  
        if (heightLeft > 0) pdf.addPage();
      }
    }
  
    pdf.save("Voucher.pdf");
  };
  


  return (
  
      <div className='printing'>
            <Button style={{ backgroundColor: "#2C2C2C", color: "#ffffff", width: "150px", marginLeft: '50px' }}
              type="submit"
              value="Submit"
              onClick={() => printDocument()}
            >
              pdf
            </Button>
 <div id="divToPrint"  className="mt4"> 
        
    <div style={{ border: 'solid' ,marginLeft:'10px',paddingTop:'20px',marginRight:'10px'}}>

      <PrintStyle >
   
        <div className='print-header' style={{ alignContent: 'center', display: 'inherit',marginTop:'-30px' }}>
          <div className='header-row' >

            <img src={log} alt="farazandishan" />
           
          </div>
          <div style={{float:'right',marginTop:'-140px',paddingTop:'10px',paddingRight:'50px'}} >
          {/* {solveOnlineImg}  */}
             <img src={prese_UrlFile} alt="farazandishan"  style={{width:'100px',height:'100px'}}/>
             <br></br>
             {Prese_Name}

            </div>
           
          <div  >
           <div  style={{float:'left', marginTop: '-120px'}}>
           Date of issue: {Mydate}
           </div>
            <div    style={{ marginLeft: '20px', fontSize: '22px', fontWeight: 'bold', alignContent: 'left', float: 'left', marginTop: '-80px' }} >
              Hotel Voucher
            </div>
          </div>

        </div>

        

          <BoxDesign className={"top-box"}>
            <div className='rowleft' style={{ border: 'solid', marginLeft: '10px', marginRight: '10px',width:'96%' ,marginTop:'-30px'}} >
              <div className='filter-title' style={{ display: 'flex' }}>

                <TableContainer component={Table}  >
                  <Table size='small' >

                    <TableBody>

                      <TableRow
                        key={1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold' ,fontFamily:'sans-serif' , fontSize: '10px', width: '70px' }} >Hotel Name:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}> Luxin Hotel</TableCell>
                      </TableRow>
                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>City: </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>Tbilisi</TableCell>
                      </TableRow>
                      <TableRow
                        key={3}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>website:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>luxinhotel.com</TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>


                <TableContainer component={Table} style={{ marginLeft: '-0px' }}  >
                  <Table size='small'  >

                    <TableBody>

                      <TableRow
                        key={1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' , width: '80px'}} >Check In:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Checkindate} </TableCell>
                      </TableRow>
                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Check Out: </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Checkoutdate}</TableCell>
                      </TableRow>
                      <TableRow
                        key={3}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Email:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>info@luxinhotel.com</TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer component={Table} style={{ marginLeft: '-0px' }}  >
                  <Table size='small'  >

                    <TableBody>

                      <TableRow
                        key={1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' , width: '80px'}} >Room:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>Standard </TableCell>
                      </TableRow>
                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Room Service: </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>Bed & Breakfast</TableCell>
                      </TableRow>
                      <TableRow
                        key={3}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Tel:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>+995592472704</TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
                {/* <div className='filters' style={{ display: 'inherit'}}>
              <img src={img} alt="/" style={{ width: '120px', height: '150px' }} />
            </div> */}
              </div>

            </div>

          </BoxDesign>
            Price
          <BoxDesign className={"top-box"}>
            <div className='rowleft' style={{ border: 'solid', marginLeft: '10px', marginRight: '10px',width:'96%' ,marginTop:'10px'}} >
              <div className='filter-title' style={{ display: 'flex' }}>

                <TableContainer component={Table}  >
                  <Table size='small' >

                    <TableBody>

                      <TableRow
                        key={1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold' ,fontFamily:'sans-serif' , fontSize: '10px', width: '70px' }} >Night:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}> {Night_No}</TableCell>
                      </TableRow>
                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>Breakfas: </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>{Reserv_BreakfastAmount}$</TableCell>
                      </TableRow>
                      <TableRow
                        key={3}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>Discount:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>{Reserv_Discount}$</TableCell>
                      </TableRow>
                      <TableRow
                        key={4}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>Rate:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold',fontFamily:'sans-serif', fontSize: '10px' }}>{Reserv_Rate}</TableCell>
                      </TableRow>
     
                    </TableBody>
                  </Table>
                </TableContainer>


                <TableContainer component={Table} style={{ marginLeft: '-0px' }}  >
                  <Table size='small'  >

                    <TableBody>

                    <TableRow
                        key={1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' , width: '80px'}} >PerNight:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Base_Price}$ </TableCell>
                      </TableRow>
                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Extra: </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_ExtraAmount}$</TableCell>
                      </TableRow>
                      <TableRow
                        key={3}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>prepaymen:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_prepayment}$</TableCell>
                      </TableRow>
                      <TableRow
                        key={4}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Gel Price:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Gel}₾</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <TableContainer component={Table} style={{ marginLeft: '-0px' }}  >
                  <Table size='small'  >

                    <TableBody>

                      <TableRow
                        key={1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' , width: '80px'}} >Sum:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Price}$ </TableCell>
                      </TableRow>
                      <TableRow
                        key={2}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Other: </TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Other}$</TableCell>
                      </TableRow>
                      <TableRow
                        key={3}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell component="th" scope="row" style={{ fontWeight: 'bold', fontSize: '10px' }}>Total:</TableCell>
                        <TableCell align="left" style={{ fontWeight: 'bold', fontSize: '10px' }}>{Reserv_Total}$</TableCell>
                      </TableRow>

                    </TableBody>
                  </Table>
                </TableContainer>
                {/* <div className='filters' style={{ display: 'inherit'}}>
              <img src={img} alt="/" style={{ width: '120px', height: '150px' }} />
            </div> */}
              </div>

            </div>

          </BoxDesign>
          <br></br>
          <div style={{ border: 'solid', fontSize: '10px', fontWeight: 'bold', height: '250px',marginTop:'-10px', marginLeft: '10px', marginRight: '10px' }}>
            <BoxDesign className={"filters"}>
              passneger Detail
              <TableContainer component={Paper} style={{ width: 'auto' }}>
                <Table sx={{ minWidth: 580 }} aria-label="simple table">
                  <TableHead style={{ backgroundColor: '#F2F2F2' }}>
                    <TableRow >
                      <TableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>First Name</TableCell>
                      <TableCell align="left" style={{ fontSize: '10px', fontWeight: 'bold' }} >Last Name</TableCell>
                      <TableCell align="left" style={{ fontSize: '10px', fontWeight: 'bold' }} >Passport No</TableCell>
                      <TableCell align="left" style={{ fontSize: '10px', fontWeight: 'bold' }}>Telephone (mobile number) </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {DataView.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{  border: 0, fontSize: '10px', fontWeight: 'bold' ,fontFamily:'Times-New-Roman' }}
                    >
                      <TableCell component="th" scope="row">{row.Com_FName}</TableCell>
                      <TableCell align="left">{row.Com_LName}</TableCell>
                      <TableCell align="left">{row.Com_Pass_No}</TableCell>
                      <TableCell align="left">{row.Pass_PhonNo}</TableCell>
                    </TableRow>
                  ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </BoxDesign>

          </div>
          <div className='top-box' style={{ border: 'solid', marginTop: '10px', marginLeft: '10px', marginRight: '10px' }}>

            <div className='title' style={{ marginLeft: '20px', textAlign: 'left', fontSize: '12', fontWeight: 'bold' }} >
              Location

            </div>
            <BoxDesign className={"top-box"} style={{ marginTop: '20px' }}>



              <img src={hmap} width="95%" height="200px" style={{ border: 0 }} referrerpolicy="no-referrer-when-downgrade"></img>

            </BoxDesign>
          </div>
          <BoxDesign className={"top-box"}>

 
            <div className='top-box' style={{ marginLeft: '20px', marginTop: '10px', textAlign: 'left', fontSize: '12px', fontWeight: 'bold' }} >

            Adress:Avlabari SQ. konstantin Eristavi  5 Luxin Hotel, Tbilisi




              {/* </BoxDesign>
      <BoxDesign className={"top-box"}> */}
              <div style={{ marginLeft: '10px', marginTop: '10px', textAlign: 'left' }}>

                Location: Avlabari , Tbilisi, Georgia
              </div>
              <br></br>
            </div>
          </BoxDesign>



     
      </PrintStyle>
      <br></br>
    </div>


    </div>
    </div>

  )
}